<template>
  <div
    class="designer-panel-section"
    :class="{open:open}"
  >
    <header>
      <el-row type="flex">
        <el-col>
          <h3>{{ title }}</h3>
        </el-col>
        <el-col>
          <button
            @click="toggle"
            class="btn-toggle"
          >
            <i
              v-if="open"
              class="icon-expand_less"
            />
            <i
              v-else
              class="icon-expand_more"
            />
          </button>
        </el-col>
      </el-row>
    </header>
    <main>
      <slot/>
    </main>
  </div>
</template>

<script>
export default {
  name: 'DesignerPanelSection',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      open: true
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
.designer-panel-section {
  header {
    background-color: #fff;
    border-bottom: 1px solid #dddddd;
    height: 50px;
    box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.2);
    h3 {
      line-height: 46px;
      padding-left: 10px;
      color: #666666;
      @include font-primary(13px, regular);
    }
    .col:last-child {
      width: 50px;
    }
    .btn-toggle {
      width: 50px;
      height: 50px;
      background-color: transparent;
      border: none;
      border-left: 1px solid #dddddd;
      float: right;
      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }
  main {
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
  }

  &.open {
    main {
      max-height: 10000px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-toggle-panel.vue